class Accounts {
    constructor(options){
        if(options){
            this.client = options.client
        }
    }
    fetch(options){
        let optionsStr = []
        Object.keys(options).forEach((key)=>{
            if(options[key]){
                optionsStr.push(`${key}=${options[key]}`)
            }
        })
        optionsStr = optionsStr.join('&')
        if(optionsStr){
            optionsStr = `?${optionsStr}`
        }
        return this.client.get(`/accounts${optionsStr}`)
    }
    authenticatorCheck(options){
        return this.client.post(`/accounts/authenticator-check`, options)
    }
    authenticatorOwnershipTransfer(options){
        return this.client.post(`/accounts/authenticator-ownership-transfer`, options)
    }
    fetchSession(options){
        let client = this.client
        client.defaults.timeout = 3000
        return client.put(`/accounts/authenticate`)
    }
    create(options){
        if((options.emailOrPhone || '').includes('@')){
            options.email = options.emailOrPhone
        }else{
            options.phone = options.emailOrPhone
        }

        delete options.emailOrPhone
        delete options.passwordConfirmation
        return this.client.post('/accounts', options)
    }
    resetPassword(options){
        return this.client.put(`/accounts/reset-password`, options)
    }
    getMagicLink(options){
        return this.client.put(`/accounts/magic-link`, options)
    }
    authenticate(options){
        return this.client.put('/accounts/authenticate', options)
    }
    update(options){
        options.url = window.location.href
        return this.client.put('/accounts', options)
    }
}

export default Accounts


// WEBPACK FOOTER //
// ./lib/apiClient/accounts.js